import { useState } from "react";
import { Slider as ChakraSlider, Flex, SliderFilledTrack, SliderThumb, SliderTrack, Spacer, Text, Tooltip, useColorModeValue } from "@chakra-ui/react";

type SliderProps = {
  labelId: string,
  value: number,
  onChange: (value: number) => void,
  step: number,
  minValue: number,
  maxValue: number,
  minLabel?: string,
  maxLabel?: string,
}

function Slider({ labelId, value, onChange, step=1, minValue, maxValue, minLabel, maxLabel }: SliderProps) {
  const [showTooltip, setShowTooltip] = useState<boolean>(false);
  const bgColor = useColorModeValue("primary.700", "primary.300");

  return(
    <>
      <ChakraSlider
        aria-labelledby={labelId}
        colorScheme="primary"
        step={step}
        min={minValue}
        max={maxValue}
        value={value}
        onChange={(value: number) => onChange(value)}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
      >
        <SliderTrack>
          <SliderFilledTrack />
        </SliderTrack>
        <Tooltip
          hasArrow
          bg={bgColor}
          placement="top"
          isOpen={showTooltip}
          label={`${value}`}
        >
          <SliderThumb />
        </Tooltip>
      </ChakraSlider>
      <Flex>
        <Text fontSize="0.7rem" fontWeight={500}>{minLabel || minValue}</Text>
        <Spacer />
        <Text fontSize="0.7rem" fontWeight={500}>{maxLabel || maxValue}</Text>
      </Flex>
    </>

  );
}

export default Slider;
